(function () {
  'use strict';
  if (window.MonroevaleOffers) return;
  const states = new WeakMap();
  const viewed = new Set();
  const consent = () => {
    const p = window.Shopify?.customerPrivacy;
    return !!p && ['analyticsProcessingAllowed','marketingAllowed','saleOfDataAllowed'].every(key=>typeof p[key]==='function') && p.analyticsProcessingAllowed() && p.marketingAllowed() && p.saleOfDataAllowed();
  };
  const amount = (minor,currency) => new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency}).format(minor/100);
  const emit = (name, data) => window.MonroevaleAttribution?.event(name,data);
  const element = (tag, cls, text) => {const el=document.createElement(tag);el.className=cls;if(text)el.textContent=text;return el;};
  const offerIcon = (cls, paths) => {
    const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.setAttribute('class',cls);svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('aria-hidden','true');svg.setAttribute('focusable','false');
    for(const d of paths){const p=document.createElementNS(svg.namespaceURI,'path');p.setAttribute('d',d);svg.append(p);}
    return svg;
  };
  const offerInputMode = mode => {if(document.documentElement.dataset.mvOfferInput!==mode)document.documentElement.dataset.mvOfferInput=mode;};
  offerInputMode('pointer');
  document.addEventListener('pointerdown',()=>offerInputMode('pointer'),{capture:true,passive:true});
  document.addEventListener('keydown',e=>{if(['Tab','ArrowLeft','ArrowRight','ArrowUp','ArrowDown',' '].includes(e.key))offerInputMode('keyboard');},true);
  function comparison(config, unitPrice, quantity, saleTotal) {
    const source=config.comparison||{};
    let defaults=source.defaults||{};
    if(typeof defaults==='string'){try{defaults=JSON.parse(defaults);}catch{defaults={};}}
    const layers=[defaults,source.profile,source.product].filter(v=>v&&typeof v==='object'&&!Array.isArray(v));
    const settings=Object.assign({},...layers),multipliers=Object.assign({},...layers.map(v=>v.multipliers||{})),overrides=Object.assign({},...layers.map(v=>v.overrides||{}));
    if(settings.enabled!==true||!Number.isSafeInteger(unitPrice)||unitPrice<0||!Number.isSafeInteger(saleTotal))return null;
    const explicit=overrides[String(quantity)],m=Number(multipliers[String(quantity)]),hundredths=Math.round(m*100);
    let whole;
    if(explicit!==undefined&&explicit!==null&&explicit!=='')whole=Number(explicit);
    else {
      if(!Number.isSafeInteger(hundredths)||hundredths<=0||Math.abs(m*100-hundredths)>.00001)return null;
      // Liquid money is scaled by 100, including currencies without fractional units.
      const numerator=unitPrice*hundredths+5000;
      if(!Number.isSafeInteger(numerator))return null;
      whole=Math.floor(numerator/10000);
    }
    if(!Number.isSafeInteger(whole)||whole<=saleTotal/100)return null;
    return {value:whole,label:settings.label||'Retail comparison'};
  }
  function snapshot(form) {
    const root=form?.closest('product-info'), widget=root?.querySelector('mv-offer-tiers');
    const config=widget?.config,variant=config?.variants.find(v=>v.id===form.querySelector('[name=id]')?.value);
    const quantity=Number(root?.querySelector('[name=quantity]')?.value||1);
    const tier=config?.tiers.find(t=>t.quantity===quantity);
    return {product:root?.dataset.productId||'',variant:variant?.id||form?.querySelector('[name=id]')?.value||'',
      profile:config?.profile||'',tier:config?(tier?.id||'custom'):'',quantity,total:variant?variant.price*quantity:undefined,
      currency:config?.currency||window.Shopify?.currency?.active||'USD',
      vip:form?.querySelector('[name="properties[_vip_rebill_amount]"]')?'on':'off',config_version:'1'};
  }
  function view(el,type,key,form) {
    if(!el)return;
    const observer=new IntersectionObserver(entries=>{
      if(entries.some(e=>e.isIntersecting)&&consent()&&!viewed.has(key)){
        viewed.add(key);emit(type,snapshot(form));observer.disconnect();
      }
    },{threshold:.25});
    observer.observe(el);
    const resume=()=>{if(consent()&&!viewed.has(key)){const r=el.getBoundingClientRect();if(r.bottom>0&&r.top<innerHeight){viewed.add(key);emit(type,snapshot(form));observer.disconnect();}}};
    document.addEventListener('visitorConsentCollected',resume);
    return ()=>{observer.disconnect();document.removeEventListener('visitorConsentCollected',resume);};
  }
  function trackingDate(config,now) {
    if(!config.confirmed||!config.country||!Number.isFinite(now))return null;
    const parts=Object.fromEntries(new Intl.DateTimeFormat('en-US',{timeZone:config.zone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date(now)).map(p=>[p.type,p.value]));
    const offset=Number(config.days);
    if(!Number.isInteger(offset)||offset<0||offset>30)return null;
    const year=+parts.year,date=new Date(Date.UTC(year,+parts.month-1,+parts.day,12));
    const weekdays=Array.isArray(config.weekends)?config.weekends:[0,6],blackouts=Array.isArray(config.blackouts)?config.blackouts:[];
    const skip=()=>config.mode==='business'&&(weekdays.includes(date.getUTCDay())||blackouts.includes(date.toISOString().slice(0,10)));
    if(config.cutoff){
      if(!/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(config.cutoff))return null;
      if(parts.hour+':'+parts.minute>=config.cutoff)date.setUTCDate(date.getUTCDate()+1);
    }
    let remaining=offset,guard=0;
    while(remaining>0&&guard++<370){date.setUTCDate(date.getUTCDate()+1);if(!skip())remaining--;}
    while(skip()&&guard++<370)date.setUTCDate(date.getUTCDate()+1);
    if(guard>=370)return null;
    return new Intl.DateTimeFormat(document.documentElement.lang||'en',{timeZone:'UTC',weekday:'short',month:'short',day:'numeric',...(date.getUTCFullYear()!==year?{year:'numeric'}:{})}).format(date);
  }
  class TrackingPanel extends HTMLElement {
    connectedCallback(){
      try{
        this.config=JSON.parse(this.querySelector('[data-tracking-config]').textContent);
        this.start=performance.now();this.message=this.querySelector('[data-tracking-message]');this.fallback=this.message.innerHTML;
        this.refresh=()=>{try{const now=this.config.server+performance.now()-this.start,date=trackingDate(this.config,now);this.message.textContent=date?this.config.body.replace('{date}',date):'';if(!date)this.message.innerHTML=this.fallback;}catch{this.message.innerHTML=this.fallback;}};
        const destinations=JSON.parse(this.querySelector('[data-shipping-destinations]').textContent);
        const names=new Intl.DisplayNames([document.documentElement.lang||'en'],{type:'region'});
        this.stopCountry=window.MonroevaleCountry?.subscribe(({country,source})=>{
          const name=country&&/^[A-Z]{2}$/.test(country)?names.of(country):'';
          const allowed=this.config.allowed;
          const eligible=source==='ip'&&destinations.includes(country)&&name&&name!==country&&(!allowed?.length||allowed.includes(country));
          this.config.country=eligible?country:'';
          this.dataset.countrySource=eligible?source:'unknown';
          this.querySelector('[data-tracking-heading]').textContent=eligible?(this.config.heading||'Tracked shipping to {country}.').replace('{country}',name):'Tracked shipping';
          this.refresh();
        });
        this.refresh();this.timer=setInterval(this.refresh,60000);
        document.addEventListener('visibilitychange',this.refresh);
        this.stopView=view(this,'tracking_panel_view','shipping-'+this.closest('product-info')?.dataset.productId,this.closest('form'));
      }catch{/* Existing shipping policy link remains usable. */}
    }
    disconnectedCallback(){clearInterval(this.timer);document.removeEventListener('visibilitychange',this.refresh);this.stopView?.();this.stopCountry?.();}
  }
  class OfferTiers extends HTMLElement {
    connectedCallback(){
      try{
        this.config=JSON.parse(this.querySelector('[data-offer-config]').textContent);
        this.dataset.design='floating-crest';
        this.root=this.closest('product-info');this.form=document.getElementById(this.dataset.form);
        this.input=this.root.querySelector('input[name=quantity]');
        if(!this.input||!this.form) return;
        if(!this.config.tiers.length||this.config.tiers.length>3||new Set(this.config.tiers.map(t=>t.quantity)).size!==this.config.tiers.length) throw Error('Invalid tier configuration');
        this.cards=this.querySelector('[data-offer-cards]');this.status=this.querySelector('[data-offer-status]');
        this.cards.replaceChildren();
        this.dataset.count=this.config.tiers.length;this.style.setProperty('--tiers',this.config.tiers.length);
        for(const tier of this.config.tiers){
          if(!Number.isSafeInteger(tier.quantity)||tier.quantity<1||!tier.title)throw Error('Invalid tier');
          const card=element(this.config.tiers.length>1?'label':'div','mv-offer-card');card.dataset.single=String(this.config.tiers.length===1);
          if(this.config.tiers.length>1){
            const radio=document.createElement('input');radio.type='radio';radio.name='mv-offer-'+this.root.dataset.section;radio.value=String(tier.quantity);radio.setAttribute('aria-label',tier.title);
            card.append(radio);radio.addEventListener('change',()=>{
              if(!radio.checked)return;const previous=this.lastTier;this.input.value=radio.value;
              this.input.dispatchEvent(new Event('change',{bubbles:true}));this.refresh();
              if(previous!==tier.id)emit('offer_tier_select',{...snapshot(this.form),previous_tier:previous||''});
            });
          }
          const selector=element('span','mv-offer-selector');selector.setAttribute('aria-hidden','true');card.append(selector);
          const title=tier.titleMode==='auto'?(this.config.buyLabel||'Buy {quantity}').replace('{quantity}',tier.quantity):tier.title;
          const name=element('span','mv-offer-name');
          name.append(element('span','mv-offer-title',title));
          const content=element('span','mv-offer-copy');content.append(name);
          if(tier.subtitle)content.append(element('span','mv-offer-subtitle',tier.subtitle));
          const pricing=element('span','mv-offer-pricing'),reference=element('del','mv-offer-reference');reference.hidden=true;
          pricing.append(element('span','mv-offer-price'),reference);
          const bridge=element('span','mv-offer-bridge');bridge.setAttribute('aria-hidden','true');
          bridge.append(offerIcon('mv-offer-arrow',['M4 12h15m-6-6 6 6-6 6']));
          const badges=element('span','mv-offer-badges');
          if(tier.badge){const badge=element('span','mv-offer-badge',tier.badge);if(['popular','popularity'].includes(tier.badgeKind)){badge.classList.add('mv-offer-popular');card.dataset.popular='true';}badges.append(badge);}
          if(tier.shippingBadge){const badge=element('span','mv-offer-shipping-badge');badge.append(offerIcon('mv-offer-truck',['M2 5h12v12H2zM14 9h4l4 4v4h-8','M6 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6M18 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6']),element('span','',tier.shippingBadge));badges.append(badge);}
          card.append(content,bridge,pricing,badges);
          card.append(element('span','mv-offer-reason'));this.cards.append(card);tier.card=card;
        }
        const quantityForm=this.closest('.product-form__quantity');
        if(quantityForm&&!quantityForm.querySelector('.mv-other-quantity')){
          const details=document.createElement('details');details.className='mv-other-quantity';details.append(element('summary','','Other quantity'));
          const native=[...quantityForm.children].filter(e=>e!==this&&!e.matches('[data-offer-status]'));
          native.forEach(e=>details.append(e));quantityForm.append(details);details.hidden=!this.config.manual;
          this.other=details;
        }
        this.onChange=e=>{
          if(e.target.name==='id')requestAnimationFrame(()=>this.refresh());
          else if(e.target===this.input){
            const previous=this.lastTier;this.refresh();
            if(e.isTrusted&&e.type==='change'&&previous!==this.lastTier)emit('offer_tier_select',{...snapshot(this.form),previous_tier:previous||''});
          }
        };
        this.root.addEventListener('change',this.onChange);
        this.root.addEventListener('input',this.onChange);
        if(typeof subscribe==='function'){
          this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{if(String(data.sectionId)===this.root.dataset.section)this.refresh();});
          this.unsubscribeQuantity=subscribe(PUB_SUB_EVENTS.quantityUpdate,()=>this.refresh());
        }
        this.refresh(true);this.dataset.ready='true';
        this.measuredWidth=undefined;
        this.layoutLabels=()=>{
          this.toggleAttribute('data-large-text',[...this.querySelectorAll('.mv-offer-name')].some(name=>parseFloat(getComputedStyle(name).fontSize)>=28));
          this.querySelectorAll('.mv-offer-popular').forEach(badge=>badge.closest('.mv-offer-card').style.setProperty('--mv-crest-inset',Math.max(19,badge.getBoundingClientRect().height-4)+'px'));
          const width=this.clientWidth;if(width===this.measuredWidth)return;this.measuredWidth=width;
          const count=this.config.tiers.length,style=getComputedStyle(this.cards),gap=parseFloat(style.columnGap)||0;
          const card=this.cards.firstElementChild,cardStyle=getComputedStyle(card);
          const padding=parseFloat(cardStyle.paddingLeft)+parseFloat(cardStyle.paddingRight)+parseFloat(cardStyle.borderLeftWidth)+parseFloat(cardStyle.borderRightWidth);
          const capacity=(width-gap*(count-1))/count-padding;
          const canvas=document.createElement('canvas'),ctx=canvas.getContext('2d');
          const needsStack=[...this.querySelectorAll('.mv-offer-name')].some(name=>{
            ctx.font=getComputedStyle(name).font;
            return ((name.querySelector('.mv-offer-title')?.textContent||name.textContent).match(/\S+/g)||[]).some(word=>ctx.measureText(word).width>capacity);
          });
          this.toggleAttribute('data-text-stack',count>1&&needsStack);
        };
        this.resizeObserver=new ResizeObserver(this.layoutLabels);this.resizeObserver.observe(this);
        this.layoutLabels();
        document.fonts?.ready.then(()=>{if(this.isConnected){this.measuredWidth=undefined;this.layoutLabels();}});
        if(this.dataset.gallery==='compact')this.root.dataset.mvOfferCompact='true';
        this.stopView=view(this,'offer_module_view','offer-'+this.config.product,this.form);
        const vip=this.form.querySelector('.mv-vip-card');
        this.stopVip=view(vip,'vip_disclosure_view','vip-'+this.config.product,this.form);
      }catch(e){
        this.removeAttribute('data-ready');
        this.input?.setCustomValidity('');
        const details=this.closest('.product-form__quantity')?.querySelector('.mv-other-quantity');
        if(details){[...details.children].filter(n=>n.tagName!=='SUMMARY').forEach(n=>details.before(n));details.remove();}
        if(window.Shopify?.designMode)console.warn('Monroevale offer fallback',e.message);
      }
    }
    refresh(initial=false){
      if(this.refreshing)return;this.refreshing=true;
      try{
        const v=this.config.variants.find(v=>v.id===this.form.querySelector('[name=id]')?.value);
        const min=Number(this.input.min)||1,step=Number(this.input.step)||1,max=this.input.hasAttribute('max')?Number(this.input.max):Infinity;
        const remaining=v?.tracked?Math.max(0,v.inventory-Number(this.input.dataset.cartQuantity||0)):Infinity;
        const reason=q=>!v?.available?'Unavailable':q<min?'Minimum '+min:q>Math.min(max,remaining)?'Unavailable quantity':(q-min)%step!==0?'Choose multiples of '+step:'';
        const valid=this.config.tiers.filter(t=>!reason(t.quantity));
        let q=Number(this.input.value),tier=this.config.tiers.find(t=>t.quantity===q);
        if(initial&&!states.has(this.form)){
          const preferred=valid.find(t=>t.id===this.config.defaultTier);
          if(preferred&&q===min)q=preferred.quantity;
        }
        if((!tier&&!this.config.manual)||reason(q)){
          if(valid.length){q=[...valid].sort((a,b)=>a.quantity-b.quantity)[0].quantity;this.status.textContent=initial?'':'Quantity adjusted to an available option.';}
          else if(!this.config.manual){this.status.textContent='These quantities are unavailable for this option.';}
        }
        if(String(q)!==this.input.value){this.input.value=String(q);this.input.dispatchEvent(new Event('change',{bubbles:true}));}
        this.lastTier=this.config.tiers.find(t=>t.quantity===q)?.id||'custom';
        states.set(this.form,snapshot(this.form));
        for(const t of this.config.tiers){
          const issue=reason(t.quantity),radio=t.card.querySelector('input');
          if(radio){radio.disabled=!!issue;radio.checked=t.quantity===q;radio.setAttribute('aria-label',t.quantity+' '+(t.quantity===1?this.config.unit:this.config.unitPlural||'items')+(t.titleMode==='auto'?'':', '+t.title)+', '+(v?amount(v.price*t.quantity,this.config.currency):'Unavailable')+(issue?', '+issue:''));}
          t.card.dataset.selected=String(t.quantity===q);t.card.dataset.disabled=String(!!issue);
          t.card.querySelector('.mv-offer-price').textContent=v?amount(v.price*t.quantity,this.config.currency):'Unavailable';
          const reference=t.card.querySelector('.mv-offer-reference'),ref=v?.available?comparison(this.config,v.price,t.quantity,v.price*t.quantity):null;
          reference.hidden=!ref;
          reference.replaceChildren();
          if(ref){reference.append(element('span','visually-hidden',ref.label+' '),document.createTextNode(new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.config.currency,minimumFractionDigits:0,maximumFractionDigits:0}).format(ref.value)));reference.dataset.value=String(ref.value);}
          else delete reference.dataset.value;
          t.card.querySelector('.mv-offer-reason').textContent=issue;
        }
        const invalid=!!reason(q)||(!this.config.manual&&!valid.length);
        this.input.setCustomValidity(invalid?'Please choose an available quantity.':'');
        const main=this.form.querySelector('button[name=add]');
        if(main){
          if(invalid){main.dataset.mvOfferBlocked='true';main.disabled=true;}
          else if(main.dataset.mvOfferBlocked==='true'){delete main.dataset.mvOfferBlocked;if(v?.available)main.disabled=false;}
          if(main.hasAttribute('data-mv-vip-invalid'))main.disabled=true;
        }
        const summary=this.form.querySelector('[data-offer-summary]');
        if(summary){
          summary.querySelector('span').textContent=q+' '+(q===1?this.config.unit:(this.config.unitPlural||'items'))+(v?.title&&v.title!=='Default Title'?' / '+v.title:'');
          summary.querySelector('strong').textContent=v&&!invalid?amount(v.price*q,this.config.currency)+' '+this.config.currency:'Check quantity';
        }
      }finally{this.refreshing=false;}
    }
    disconnectedCallback(){
      this.root?.removeEventListener('change',this.onChange);this.root?.removeEventListener('input',this.onChange);
      this.unsubscribe?.();this.unsubscribeQuantity?.();this.stopView?.();this.stopVip?.();
      this.resizeObserver?.disconnect();
    }
  }
  // Enrich the existing consent-aware entry event; do not call a second Meta pixel.
  const pending=new WeakMap();
  document.addEventListener('submit',e=>{
    if(!e.target.matches('product-info[data-mv-direct-pdp] product-form form'))return;
    const form=e.target,main=form.querySelector('button[name=add]');
    if(main?.hasAttribute('data-mv-vip-invalid')){e.preventDefault();e.stopImmediatePropagation();return;}
    if(main?.getAttribute('aria-disabled')==='true'||!form.checkValidity())return;
    const data=snapshot(form);const cta=form.querySelector('[name="properties[_mv_cta]"]')?.value||'atc';
    const entry=form.querySelector('[name="properties[_mv_entry_id]"]')?.value||'';
    pending.set(form,{...data,cta,entry});
    if(consent()){
      for(const [key,value]of Object.entries(data.profile?{_mv_offer:data.profile,_mv_tier:data.tier,_mv_qty:String(data.quantity)}:{})){
        let input=form.querySelector(`[name="properties[${key}]"]`);if(!input){input=document.createElement('input');input.type='hidden';input.name=`properties[${key}]`;form.append(input);}input.value=value;
      }
      emit('purchase_action_click',{...data,cta,entry});
    }
  },true);
  document.addEventListener('shopify:cart:lines-update',e=>{
    const form=e.target.closest('product-form')?.querySelector('form');
    const detail=e.detail||e;if(!form||detail.action!=='add'||!detail.promise?.then)return;
    const data=pending.get(form);if(!data)return;pending.delete(form);
    detail.promise.then(()=>emit('cart_submit_success',data),()=>emit('cart_submit_error',data));
  });
  window.MonroevaleOffers={snapshot,trackingDate,comparison,version:2};
  customElements.define('mv-offer-tiers',OfferTiers);
  customElements.define('mv-tracking-panel',TrackingPanel);
})();
